export const CUSTOMER_SELF_CONTRACTOR_ID = '8af2f390-4ac2-e811-80e8-00155da51821' //TODO: Do not hard code GUIDs
